import { di } from 'react-magnetic-di';
import { useIsRouting, useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { ConversationProvider } from '@atlassian/unified-help-common/src/types';
import { useIsLastMessageFromHelpSeeker, useIsLastAssistantMessageGenerated } from '../../../store/converse';

export const useIsInputEnabled = () => {
    di(useProvider, useIsLastAssistantMessageGenerated, useIsLastMessageFromHelpSeeker, useIsRouting);
    const provider = useProvider();
    const isRouting = useIsRouting();
    const [isLastMessageFromHelpSeeker] = useIsLastMessageFromHelpSeeker();
    const [isLastAssistantMessageGenerated] = useIsLastAssistantMessageGenerated();

    if (isRouting) {
        return false;
    }

    if (!provider || provider === ConversationProvider.VIRTUAL_AGENT) {
        return true;
    }

    return isLastAssistantMessageGenerated && !isLastMessageFromHelpSeeker;
};
